import type { z } from "zod";

import { zSchema } from "../../../../entity";

import { zWithLanguage } from "~/shared/zod";

const zIn = zSchema
  .pick({
    id: true,
  })
  .merge(
    zSchema
      .omit({
        id: true,
      })
      .partial(),
  )
  .merge(zWithLanguage);
type In = z.infer<typeof zIn>;

export { zIn };
export type { In };
